import navigationConfig from 'app/fuse-configs/navigationConfig';
import navigationConfigOwner from 'app/fuse-configs/navigationConfigOwner';
import initialNavigationConfig from 'app/fuse-configs/initialNavigationConfig';
import * as Actions from '../../actions/fuse';

let isRole = null;
const userData = JSON.parse(localStorage.getItem('userData'))
if (userData && userData !== undefined && userData !== null && userData.userType) {
	isRole = userData.userType
}
let navigationData = null;

if (isRole && isRole !== null && isRole === 'Admin') {
	navigationData = navigationConfig
} else if (isRole && isRole !== null && isRole === 'Owner') {
	navigationData = navigationConfigOwner
} else{
	navigationData = initialNavigationConfig
}

const initialState = navigationData;


const navigation = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_NAVIGATION: {
			return [...state];
		}
		case Actions.SET_NAVIGATION: {
			return [...action.navigation];
		}
		case Actions.RESET_NAVIGATION: {
			return [...initialState];
		}
		default: {
			return state;
		}
	}
};

export default navigation;
